// global process
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import { install } from 'redux-loop';
import authActions from './widget/action/auth';
import reducers from './widget/reducer';
import endpoints from './widget/define/endpoints';
import authOptions from './widget/define/auth';
import AuthMiddleware from './widget/middleware/auth';
import { Auth0Provider } from './widget/context/auth0';
import { CoreProvider } from './widget/context/core';
import SmartSearchContextProvider from './widget/context/smartSearch';

// initialize redux store
const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    typeof window !== 'undefined' &&
    window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']) ||
  compose;
const store = createStore(
  reducers,
  {},
  composeEnhancers(install(), applyMiddleware(AuthMiddleware))
);

export const initWidget = function (name, component, props) {
  const container = document.querySelectorAll('[data-widget="' + name + '"]');

  // skip if container is not present
  if (!container) {
    return;
  }

  Array.prototype.forEach.call(container, (_container) => {
    let _component,
      prop,
      _prop,
      _props = {};

    // normalize props from container data set
    for (prop in _container.dataset) {
      // skip unwanted props
      if (!Object.prototype.hasOwnProperty.call(_container.dataset, prop))
        continue;
      if (prop.search(/^wp/) === -1) continue;
      if (prop === 'wp') continue;

      // normalize property name
      //  strip 'wp' prefix and lowercase first char
      _prop = prop.charAt(2).toLowerCase() + prop.slice(3);

      // get property
      _props[_prop] = _container.dataset[prop];
    }

    // sanitize props
    if (component.sanitizeProps) {
      _props = component.sanitizeProps(_props);
    }

    // add static props
    Object.assign(_props, props);

    // instantiate the component
    _component = React.createElement(component, _props);

    // render the widget
    ReactDOM.render(
      <Provider store={store}>
        <Auth0Provider>
          <CoreProvider endpoints={props.endpoints}>
            <SmartSearchContextProvider>
              {_component}
            </SmartSearchContextProvider>
          </CoreProvider>
        </Auth0Provider>
      </Provider>,
      _container
    );
  });
};

const init = function () {
  store.dispatch(authActions.init(authOptions, endpoints));
};

// initialize default widgets
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init.bind(this));
} else {
  init();
}

export const secureLocalStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      return localStorage.setItem(key, value);
    } catch (error) {
      return null;
    }
  },
};
